// extracted by css-extract-rspack-plugin
export default {"container":"CompactThread-module__container__f9JEH","comments":"CompactThread-module__comments__b7Mz3","moreReplies":"CompactThread-module__moreReplies__QeVX_"};